const itemFactory = ({
  alias,
  title,
  image,
  address,
  description,
  notice,
  hidden,
  lineId,
  lineFriendUrl,
  phoneNumber,
  params,
  fbFanpageUrl
} = {}) => {
  return {
    "alias": alias ?? "taipei",
    "title": title ?? "台北店",
    "image": image ?? "https://assets.codepen.io/1759070/section4-image-1%402x.png",
    "address": address ?? "臺北市中山區林森北路247號2樓",
    "description": description ?? "我們好好台北店一直秉持著「顧客至上．服務．創新．效率」的經營理念，不斷地提升服務品質，期許每位員工及專門店服務人員，都能以熱情真誠的態度，服務每一位顧客，讓每位顧客體驗、感受到我們的用心！",
    "notice": notice ?? null,
    "hidden": hidden ?? 0,
    "lineId": lineId ?? "wegoodgoodtaipei",
    "lineFriendUrl": lineFriendUrl ?? "https://line.me/R/ti/p/@740xxcqk",
    "phoneNumber": phoneNumber ?? "02-27422526",
    "params": params ?? {
      "serviceTimeSetting": {
        "1": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 1
        },
        "2": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "3": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "4": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "5": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "6": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "7": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        }
      }
    },
    "fbFanpageUrl": fbFanpageUrl ?? "https://www.facebook.com/wegoodgood"
  }
};

export const STORE_LIST = [
  {
    "alias": "taipei",
    "title": "台北店",
    "image": "https://assets.codepen.io/1759070/section4-image-1%402x.png",
    "address": "臺北市中山區林森北路247號2樓",
    "description": "我們好好台北店一直秉持著「顧客至上．服務．創新．效率」的經營理念，不斷地提升服務品質，期許每位員工及專門店服務人員，都能以熱情真誠的態度，服務每一位顧客，讓每位顧客體驗、感受到我們的用心！",
    "notice": null,
    "hidden": 0,
    "lineId": "wegoodgoodtaipei",
    "lineFriendUrl": "https://line.me/R/ti/p/@740xxcqk",
    "phoneNumber": "02-27422526",
    "params": {
      "serviceTimeSetting": {
        "1": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 1
        },
        "2": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "3": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "4": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "5": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "6": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "7": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        }
      }
    },
    "fbFanpageUrl": "https://www.facebook.com/wegoodgood"
  },
  {
    "alias": "taoyuan",
    "title": "桃園店",
    "image": "https://assets.codepen.io/1759070/section4-image-2%402x.png",
    "address": "桃園市蘆竹區南崁路一段112號",
    "description": "我們好好桃園店一直秉持著「顧客至上．服務．創新．效率」的經營理念，不斷地提升服務品質，期許每位員工及專門店服務人員，都能以熱情真誠的態度，服務每一位顧客，讓每位顧客體驗、感受到我們的用心！",
    "notice": null,
    "hidden": 0,
    "lineId": "",
    "lineFriendUrl": "https://line.me/R/ti/p/@740xxcqk",
    "phoneNumber": "02-27422526",
    "params": {
      "serviceTimeSetting": {
        "1": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 1
        },
        "2": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "3": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "4": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "5": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "6": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "7": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        }
      }
    },
    "fbFanpageUrl": "https://www.facebook.com/wegoodgood"
  },
  {
    "alias": "taichung",
    "title": "台中旗艦店",
    "image": "https://assets.codepen.io/1759070/section4-image-3%402x.png",
    "address": "台中市西屯區臺灣大道三段251號10樓",
    "description": "我們好好台中旗艦店一直秉持著「顧客至上．服務．創新．效率」的經營理念，不斷地提升服務品質，期許每位員工及專門店服務人員，都能以熱情真誠的態度，服務每一位顧客，讓每位顧客體驗、感受到我們的用心！",
    "notice": null,
    "hidden": 0,
    "lineId": "wegoodgoodtaichung",
    "lineFriendUrl": "",
    "phoneNumber": "02-27422526",
    "params": {
      "serviceTimeSetting": {
        "1": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 1
        },
        "2": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "3": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "4": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "5": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "6": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        },
        "7": {
          "start": "02:00",
          "end": "23:00",
          "lastOrder": "19:00",
          "beforehandOrder": "0",
          "isOpen": 0
        }
      }
    },
    "fbFanpageUrl": ""
  }
];

export const STORE_ITEM = itemFactory();
